import { Injectable } from '@angular/core';
import { TemplateVariantInput } from '../../entities/template-variant/template-variant';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './template-variants.graphql';

@Injectable()
export class TemplateVariantsService {
  constructor(private apolloService: ApolloService) {}

  public updateTemplateVariant(templateVariantInput: TemplateVariantInput, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_TEMPLATE_VARIANT_MUTATION,
      { templateVariantInput },
      callback
    );
  }

  public createTemplateVariant(templateVariantInput: TemplateVariantInput, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.CREATE_TEMPLATE_VARIANT_MUTATION,
      { templateVariantInput },
      callback
    );
  }

  public deleteTemplateVariant(templateVariantId: string, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.DELETE_TEMPLATE_VARIANT_MUTATION,
      { templateVariantId },
      callback
    );
  }
}
